import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
import { buyerNames } from '../data/salesData';
export function PurchasePopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentName, setCurrentName] = useState('');
  useEffect(() => {
    const showPopup = () => {
      setCurrentName(buyerNames[Math.floor(Math.random() * buyerNames.length)]);
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 5000);
    };
    const initialDelay = setTimeout(showPopup, 30000);
    const interval = setInterval(showPopup, 30000);
    return () => {
      clearTimeout(initialDelay);
      clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-157" data-mp="3iqtrgyluz1vy">
      {isVisible && <motion.div initial={{
      x: -400,
      opacity: 0
    }} animate={{
      x: 0,
      opacity: 1
    }} exit={{
      x: -400,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 200,
      damping: 25
    }} className="fixed bottom-6 left-6 z-50 max-w-sm" data-id="element-158" data-mp="1cx27m0jceedw">
          <div className="bg-white rounded-lg shadow-2xl p-4 border-l-4 border-accent relative" data-id="element-159" data-mp="1fv971q50d2bi">
            <button onClick={() => setIsVisible(false)} aria-label="Cerrar aviso" className="absolute top-2 right-2 text-gray-400 hover:text-gray-600" data-id="element-160" data-mp="1ax7p58jbj91m">
              <XIcon className="w-4 h-4" data-id="element-161" data-mp="i9v0mstlkr5o" />
            </button>

            <div className="flex items-start gap-3" data-id="element-162" data-mp="x5koyxm99gdk">
              <div className="text-2xl" data-id="element-163" data-mp="x2y8g8hdzqj7">🎉</div>
              <div className="flex-1" data-id="element-164" data-mp="s56hbgokg8g2">
                <p className="font-bold text-gray-900 text-sm mb-1" data-id="element-165" data-mp="s8atp1c6qaht">
                  {currentName}
                </p>
                <p className="text-xs text-gray-600" data-id="element-166" data-mp="23ldb1ym3z431">
                  acaba de comprar STRETCHING 360
                </p>
              </div>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}